import { defineStore } from 'pinia'
import { getAgentList, getPayerList, getLinkerList, getSalesList } from '@/api/api'

export const useBillDataStore = defineStore('billData', {
  state: () => ({
    agents: [],
    payers: [],
    links: [],
    sales: [],
    loaded: false,
    loading: false,
    timestamp: 0
  }),

  getters: {
    agentsCount: (state) => state.agents.length,
    payersCount: (state) => state.payers.length,
    linksCount: (state) => state.links.length
  },

  actions: {
    async loadData(forceReload = false) {
      if (!forceReload && (this.loaded || this.loading)) return
      if (!forceReload && Date.now() - this.timestamp < 60000) return // 1分钟缓存

      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      if (userInfo.type === 4) {
        // customer用户不加载数据，但设置loaded=true避免无限等待
        this.loaded = true
        return
      }

      this.loading = true

      try {
        const [agentsRes, payersRes, linksRes, salesRes] = await Promise.all([
          getAgentList({ page: 1, limit: 9999 }),
          getPayerList({ page: 1, limit: 9999 }),
          getLinkerList({ page: 1, limit: 9999 }),
          getSalesList({ page: 1, limit: 9999 })
        ])

        this.agents = agentsRes.code === 2000 ? (agentsRes.data.data || agentsRes.data) : []
        this.payers = payersRes.code === 2000 ? (payersRes.data.data || payersRes.data) : []
        this.links = linksRes.code === 2000 ? (linksRes.data.data || linksRes.data) : []
        this.sales = salesRes.code === 2000 ? (salesRes.data.data || salesRes.data) : []

        this.loaded = true
        this.timestamp = Date.now()
      } catch (error) {
        console.error('预加载数据失败:', error)
      } finally {
        this.loading = false
      }
    },

    clearCache() {
      this.agents = []
      this.payers = []
      this.links = []
      this.sales = []
      this.loaded = false
      this.timestamp = 0
    }
  }
})
